import { useParams } from "react-router";
import { useStore } from "../contexts/StoreContext";

function useCurrentApplicationUuid(): string {
  const { applicationUuid } = useParams<{ applicationUuid: string }>();
  const { data } = useStore();

  return applicationUuid ?? data.lendingApplicationID ?? "";
}

export { useCurrentApplicationUuid };
